var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-see"},[_c('sub-menu',[_c('menu-item',{attrs:{"link":"/see","exact":""}},[_vm._v("Official Photos")]),_vm._v(" "),_c('menu-item',{attrs:{"link":"/see/instagram","exact":""}},[_vm._v("Instagram")])],1),_vm._v(" "),_c('h1',[_vm._v("The photos")]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64250381","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/See.vue
// module id = 79
// module chunks = 0